<template lang="pug">
  div
    b-button.refresh-btn(variant="light" @click="showModal = true")
      font-awesome-icon.refresh-button(icon="redo")

    b-modal#refresh-modal(v-model="showModal" title="Forzar Recarga" no-close-on-backdrop)
      .text-center
        font-awesome-icon.mb-4(icon="exclamation-triangle" size="4x" class="exclamation-icon")
      p.text-center.font-weight-bold.question
        | ¿Estás seguro de que quieres recargar los datos?
      p.text-center.mb-0
        | Este preoceso puede tardar algunos segundos.
      p.text-center.mb-0
        | Usar esta función con demasiada frecuencia puede ralentizar el
        | sistema para todos los usuarios.
      p.text-center.mb-0
        | Por favor, úsala solo cuando sea realmente necesario.
      template(#modal-footer='{ ok, cancel, hide }')
        .d-flex.justify-content-between.w-100
          b-button(variant='secondary' @click='showModal = false') Cancelar
          b-button(
            variant='primary'
            @click='refreshDashboard'
            :disabled="loading"
          ) Aceptar
            b-spinner(v-if="loading" small)
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      showModal: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('TechniciansStore', ['listTechnicians']),
    async refreshDashboard() {
      this.$emit('refreshDashboard')
      this.showModal = false
      this.listTechnicians({ forceReload: true })
      this.$bvToast.toast('Recarga de datos exitosa', {
        title: 'Recarga de datos',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
        appendToast: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.refresh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 45px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background-color: $center-bg;
  box-shadow: none;

  &:hover,
  &:focus {
    border: none;
    background-color: #E8EAF0;
    box-shadow: none;
  }
}

.refresh-button {
  color: $blue-accent;
  font-size: 16px;
}

.exclamation-icon {
  color: $samtek-yellow;
}

p {
  font-size: 14px;
  color: $samtek-grey;
}

.question {
  font-size: 16px;
  font-weight: 700;
  color: $samtek-black;
}

#refresh-modal {
  ::v-deep .modal-content {
    padding: 20px;
    border: none;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  }

  ::v-deep .modal-header {
    padding: 0 0 20px;
    border-bottom: none;
    background-color: #fff;
  }

  ::v-deep .modal-title {
    font-size: 18px;
    font-weight: 700;
    color: $samtek-black;
  }

  ::v-deep .close {
    color: $samtek-grey;
    opacity: 1;
    text-shadow: none;

    &:hover {
      color: $danger-strong;
    }
  }

  ::v-deep .modal-body {
    padding: 0 !important;
  }

  ::v-deep .modal-footer {
    justify-content: space-between !important;
    padding: 16px 0 0 !important;
    border-top: 1px solid $table-head-bg;
  }

  ::v-deep .btn {
    height: 45px;
    padding: 0 16px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
  }

  ::v-deep .btn-secondary {
    border: 1px solid $table-head-bg;
    background-color: #fff;
    color: $samtek-black;

    &:hover,
    &:focus {
      border-color: $table-head-bg;
      background-color: $center-bg;
      color: $samtek-black;
    }
  }

  ::v-deep .btn-primary {
    border-color: $samtek-yellow;
    background-color: $samtek-yellow;
    color: $samtek-black;

    &:hover,
    &:focus {
      border-color: #F5C400;
      background-color: #F5C400;
      color: $samtek-black;
    }
  }
}
</style>
